<template>
  <div>
    <v-text-field
      v-if="!hide.includes('name')"
      label="Név"
      :error-messages="errors.name"
      v-model="cardOwner.name"
      :readonly=readonly
      filled
      :clearable="!readonly" />

    <v-text-field
      v-if="!hide.includes('email')"
      label="Email"
      :error-messages="errors.email"
      v-model="cardOwner.email"
      :readonly=readonly
      filled
      :clearable="!readonly" />

    <v-text-field
      v-if="!hide.includes('phone')"
      label="Telefon"
      :error-messages="errors.phone"
      v-model="cardOwner.phone"
      :readonly=readonly
      filled
      :clearable="!readonly" />

    <!-- <dynamic-field
      v-for="field in extraFields"
      :key="`extra-field-${field.name}`"
      :field="field"
      v-model="form.extra_fields[field.name]"
      :error-messages="errors[field.name]"
      filled
    /> -->
  </div>
</template>

<script>
export default {
  props: {
    cardOwner: {
      type: Object,
      required: true,
    },

    errors: {
      type: Object,
      default: () => ({}),
      // required: true,
    },

    readonly: {
      type: Boolean,
      default: false,
    },

    hide: {
      type: Array,
      default: () => [],
      // validator: (value) => value.find((v) => ['name', 'email'].includes(v)).length === 0,
    },
  },
};
</script>
